import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=55bad3cb&scoped=true&lang=pug&"
import script from "./patient.vue?vue&type=script&lang=ts&"
export * from "./patient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bad3cb",
  null
  
)

export default component.exports